import { Grid, Typography } from "@material-ui/core";
import type { Navigation } from "../../models/navigation";
import { Header } from "../../shared/components/header";
import { Collectibles } from "../components/collectibles";
import { useStyles } from "./collectibles.styles";

type Props = {
  navigation: Navigation[];
};

export const CollectiblesContainer = ({ navigation }: Props) => {
  const classes = useStyles();

  return (
    <Header navigation={navigation}>
      <Grid
        container
        spacing={1}
        className={classes.container}
        data-testid="collectibles"
      >
        <Grid item xs={12}>
          <Typography
            variant="h2"
            color="textPrimary"
            component="h1"
            className={classes.sectionTitle}
            data-testid="collectibles-title"
          >
            Shared Collectibles
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Collectibles />
        </Grid>
      </Grid>
    </Header>
  );
};
